import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';
import TableContainer  from '@mui/material/TableContainer';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { DateCellStyling,ContainerStyling,HeadingStyling,ContentCellStyling,TableRowStyling} from './BiogTableStyles';

export default function BiogCollections() {
  const { t } = useTranslation('common');
  return (
    <>
    <Grid2 flexDirection="row" sx={ContainerStyling}>
        <TableContainer>
          <Table aria-label="simple table">
            <TableBody>
              <TableRow
                key="1"
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>Spedag AG</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'>, Muttenz, Schweiz</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key="2"
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>Kunstkreditkommission Baselland</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'>, Liestal, Schweiz</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key="3"
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>BP (Schweiz)</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'> Zürich, Schweiz</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key="4"
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>UBS Art Collection</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key="5"
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>Hospital Federal de Uberlandia</Box>
                  <Box sx={{fontWeight : 'normal'}} component='span'>, Brasilien</Box>
                </TableCell>
              </TableRow>
              <TableRow
                key="6"
                sx={TableRowStyling}
              >
                <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                </TableCell>
                <TableCell align="left" padding="none" sx={ContentCellStyling}>
                  <Box sx={{fontWeight : 'bold'}} component='span'>und viele private Sammlungen in der Schweiz und den USA</Box>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid2>
    </>
  )
}
